import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ConfirmationModalProps } from '~/Components';
import { Route } from '~/Constants/Routes.constants';
import { routeReplacer } from '~/Helpers/String.helper';
import { AccessList, useHasAccess, useNavigation } from '~/Hooks';
import { IStaff } from '~/Models/DTO/Staff.model';
import { IMenuAction } from '~/Models/interfaces/menuAction.models';
import { useStaffDeactivationModal } from './useStaffDeactivationModal';
import { useStaffDeletionModal } from './useStaffDeletionModal';
import { useStaffUpdateModal } from './useStaffUpdateModal';

export const useStaffMenuActions = () => {
  const [confirmationModalProps, setConfirmationModalProps] = useState<ConfirmationModalProps>({
    open: false,
    cancel: {},
    confirm: {},
    title: '',
    destructive: true,
  });

  const { t } = useTranslation();
  const { navigate } = useNavigation();
  const deactivationMenuItem = useStaffDeactivationModal({ setConfirmationModalProps });
  const deletionMenuItem = useStaffDeletionModal({ setConfirmationModalProps });
  const changeToOwnerMenuItem = useStaffUpdateModal({ setConfirmationModalProps });
  const { hasAccess } = useHasAccess();
  const hasChangeOwnershipAccess = hasAccess(AccessList.CHANGE_OWNERSHIP);

  const actions: (item: IStaff) => IMenuAction[] = (item) => {
    const items: IMenuAction[] = [
      {
        name: t('app.edit'),
        onClick: () => {
          navigate(routeReplacer(Route.PROVIDER_STAFF_EDIT, { id: item.id }));
        },
      },
    ];
    if (item.isOwner) {
      return items;
    }
    items.push(deactivationMenuItem(item));
    if (item.userId && hasChangeOwnershipAccess) {
      items.push(changeToOwnerMenuItem(item));
    }
    if (item.disabled) {
      items.push(deletionMenuItem(item));
    }
    return items;
  };
  return { confirmationModalProps, actions };
};
